<template>
  <div class="ac-card-content">
    <div class="ac-header-container justify-start">
      <button
        type="button"
        class="ac-close-button"
        @click="close"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="ac-header ml-2">
        {{ selectedPlan?.name }} SMS Text Preview
      </div>
    </div>
    <div class="ac-body-container">
      <div class="sac__font-16">
        Based on your selected Membership, we send a text message to advertise bundled offers that user can acquire when joining the plan. 
      </div>
      <div class="sac__font-16 mt-4">
        *User receives offer(s), once onboarding is complete
      </div>
      <div class="border-light" />
      <div class="text-container">
        <div class="flex-row just-center sac__font-8 n50 medium">
          <span class="sac__font-8 bold">
            Today
          </span>
          9:41
        </div>
        <div class="content-container">
          <img
            v-if="(selectedPlan?.bonusComfortCredit > 0 || selectedPlan?.comfortCreditEnabled) && !selectedPlan?.bonusFilterVoucher"
            src="https://smac-images.s3.us-west-2.amazonaws.com/email/rewards-cc.png" 
            class="img-preview"
          />
          <img
            v-else-if="selectedPlan?.bonusFilterVoucher > 0 && !selectedPlan?.bonusComfortCredit && !selectedPlan?.comfortCreditEnabled"
            src="https://smac-images.s3.us-west-2.amazonaws.com/email/rewards-voucher.png" 
            class="img-preview"
          />
          <img
            v-else
            src="https://smac-images.s3.us-west-2.amazonaws.com/email/rewards-cc-voucher.png" 
            class="img-preview"
          />
          <div class="text-bubble sac__font-12">
            Hi <span class="sac__font-12 f-primary semi-bold">{memberName}</span>, it's your {{ companyName }}
            team inviting you to our loyalty platform! Join for free today to get
            {{ body }}. Sign into the SmartAC.com app to claim it. Login:
            <span class="sac__font-12 f-primary semi-bold">{maskedEmail}</span>, temporary password is your phone number. <span class="sac__font-12 f-primary semi-bold">{link}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="close"
      >
        Close Preview
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'SMSTextPreview',
  props: {
    close: Function,
  },
  computed: {
    ...mapState({
      companyName: (state) => state.admin.adminFilter.corpName,
      selectedPlan: (state) => state.customer.selectedPlan,
    }),
    body() {
      let rewards = "";

      if (this.selectedPlan) {
        if (this.selectedPlan.bonusFilterVoucher > 0) {
            rewards += `$${this.selectedPlan.bonusFilterVoucher} in free filters`;
        }
        if (this.selectedPlan.bonusComfortCredit > 0) {
            rewards += (rewards ? ", " : "") + `$${this.selectedPlan.bonusComfortCredit} instant`;
        }
        if (this.selectedPlan.comfortCreditEnabled && this.selectedPlan.comfortCreditInitial > 0) {
            const frequency = this.selectedPlan.creditAccrualFrequency === "MONTHLY" ? "mo" : "yr";
            rewards += (this.selectedPlan.bonusComfortCredit > 0 ? " + " : "") + `$${this.selectedPlan.comfortCreditInitial}/${frequency}`;
        }
        if (
            this.selectedPlan.bonusComfortCredit > 0 ||
            (this.selectedPlan.comfortCreditEnabled && this.selectedPlan.comfortCreditInitial > 0)
        ) {
            rewards += " credits toward major repairs";
        }
      }
      return rewards;
    }
  },
}
</script>

<style lang="scss" scoped>
.ac-card-content {
  background-color: #F4F6FA;
  border-radius: 24px;
}
.border-light {
  height: 1px;
  background-color: $N10;
  width: 100%;
  margin: 12px 0;
}
.text-container {
  background-color: $WHITE;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 6px 48px 24px;
  .content-container {
    width: 60%;
  }
  .img-preview {
    width: 230px;
    border-radius: 12px;
    margin-top: 8px;
  }
  .text-bubble {
    width: 200px;
    background-color: #e9e9e9;
    margin-top: 12px;
    border-radius: 12px;
    padding: 4px 8px;
  }
}
</style>
